// extracted by mini-css-extract-plugin
export var boxItems = "_ao-1";
export var boxItemsLg = "_ao-2";
export var button = "_ao-7";
export var buttonHoverless = "_ao-9";
export var buttonLg = "_ao-8";
export var filterGroupBox = "_ao-0";
export var icon = "_ao-3";
export var iconSecondary = "_ao-6";
export var iconWrapper = "_ao-4";
export var iconWrapperLg = "_ao-5";
export var truncatedLabel = "_ao-a";